import { FunctionComponent, useEffect } from "react";
import PageLayout from "@components/core/layouts/PageLayout";
import CardSection from "@components/core/section/CardSection";
import { useTranslation } from "react-i18next";
import parse from "html-react-parser";
import LinkButton from "@components/core/links/LinkButton";
import { ROUTES } from "@routes/Routes";
import { useNavigate } from "react-router-dom";

/* TODO: EXAMPLE -> Replace with data */
const ERROR_EXAMPLE = {
  code: 10,
  message: "Phone number already used.",
  labelCode: "10",
};

// TODO, this screen has been replaced with toastError, if we need to stil show this screen after showing toast, we can
const ErrorScreen: FunctionComponent = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const error = ERROR_EXAMPLE;
  const phoneAlreadyUsedError =
    error.message.includes("Phone number") &&
    error.message.includes("already used.");
  const showCustomError = phoneAlreadyUsedError;

  useEffect(() => {
    if (!error || !error.code || !error.message) {
      navigate(ROUTES.extranet.home.generate());
    }
  }, [error, navigate]);

  return (
    <PageLayout container bodyClassName="mt-0">
      <>
        {showCustomError ? (
          <CardSection title={t(`errorPage.code.${error.labelCode}.title`)}>
            <p>{parse(t(`errorPage.code.${error.labelCode}.message`))}</p>
          </CardSection>
        ) : (
          <div className="text-center">
            <div className="d-flex justify-content-center mb-48">
              {t("buttons.back")} {error && error.code} :{" "}
              {error && parse(error.message)}
            </div>
            <LinkButton
              to={ROUTES.extranet.home.generate()}
              text={t("buttons.back")}
            />
          </div>
        )}
      </>
    </PageLayout>
  );
};

export default ErrorScreen;
